export type AuthData = {
  username?: string | null
  terminalId?: string | number | null
  token: string | null
  refreshToken?: string | null
}

const AUTH_KEY = 'tp.auth'

export function loadAuth(): AuthData | null {
  try {
    const raw = localStorage.getItem(AUTH_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed
  } catch {
    return null
  }
}

export function saveAuth(auth: AuthData): void {
  try {
    localStorage.setItem(AUTH_KEY, JSON.stringify(auth))
  } catch (err) {
    console.error(err)
  }
}

export function clearAuth(): void {
  try {
    localStorage.removeItem(AUTH_KEY)
  } catch (err) {
    console.error(err)
  }
}
